export default __webpack_public_path__ + "static/media/rwca.fd21901a.png";